module.exports = "/_next/static/images/header-img-en-e66acc422a418ea064944e087e189f2b.jpg";